import React from 'react';
import { Box } from '@mui/material';
import { formatCurrency } from 'utils';
import { SummaryProps } from 'components/shared/Board/types';
import { RequestPage, AttachMoney, AutoGraph, Calculate } from '@mui/icons-material';

import { SummaryCard } from './SummaryCard';

export const Summary = ({ avgDealSize, totalActiveDeals, totalDealAmount }: SummaryProps) => {
  const renderSummaryConfiguration = [
    {
      amount: totalActiveDeals,
      label: 'Total Active Deals',
      icon: <RequestPage color="primary" />,
    },
    {
      label: 'Total Deal Amount',
      icon: <AttachMoney color="primary" />,
      amount: formatCurrency(totalDealAmount, true),
    },
    {
      label: 'Avg Deal Size',
      icon: <Calculate color="primary" />,
      amount: formatCurrency(avgDealSize, true),
    },
  ];

  return (
    <Box sx={{ display: 'flex', gap: '1rem' }}>
      {renderSummaryConfiguration.map(renderItem => (
        <SummaryCard key={renderItem.label} {...renderItem} />
      ))}
    </Box>
  );
};
